export default "__VITE_ASSET__1731e42c__"